export default "__VITE_ASSET__1c501738__"